<template>
    <div class="body-inner"
         v-loading="is_loading"
         element-loading-text="loading...">
        <section class="section-wrap">
            <div class="section-item section-left"
                 :class="{'hide-left': !$route.meta.close}">
                <a :href="'#/content/' + item.id" class="content-item"
                   v-for="(item, index) in left_arr"
                   :key="index"
                   :style="{height: item.height}">
                    <img class="content-header-image" :src="item.src"/>
                </a>
            </div>
            <div class="section-item section-right"
                 :class="{'hide-right': !$route.meta.close}">
                <a :href="'#/content/' + item.id" class="content-item"
                   v-for="(item, index) in right_arr"
                   :key="index"
                   :style="{height: item.height}">
                    <img class="content-header-image" :src="item.src"/>
                </a>
            </div>
        </section>
    </div>
</template>
<script>
    import API from '../assets/api'
    export default {
        data () {
            return {
                left_arr: [],
                right_arr: [],
                is_loading: false,
            }
        },
        created () {
            this.fetchArticleList()
        },
        methods: {
            fetchArticleList () {
                this.is_loading = true;
                API.Req_FetchArticleList().then((result) => {
                    setTimeout(() => {
                        this.is_loading = false;
                    },800);
                    result = this.autoHeight(result);
                    this.splitArr(result);
                });
            },
            splitArr (arr) {
                arr.forEach((item, index) => {
                     index % 2 === 0 ? this.left_arr.push(item) : this.right_arr.push(item);
                });
            },
            autoHeight (arr) {
                arr.forEach((item) => {
                    let height = 100 + Math.floor(Math.random() * 200) + 'px';
                    this.$set(item, 'height', height)
                });
                return arr;
            }
        },
        components: {
        }
    }
</script>
<style lang="scss">
    @import '../assets/scss/define';
    .body-inner{
        @extend %pa;
        @extend %l0;
        @extend %b0;
        @extend %t0;
        right: -15px;
        overflow-y: scroll;
    }
    .section-wrap{
        @extend %df;
        @extend %oh;
        min-height: 100%;
    }
    .section-item{
        @extend %df1;
        @extend %df;
        @extend %pr;
        @include tst(all, .8s);
        flex-direction: column;
        background-color: #000;
        padding-bottom: 6px;
    }
    .section-left{
        padding-right: 3px;
        align-items: flex-end;
        .content-item{
            text-align: right;
        }
        .section-dot-origin{
            @extend %pa;
            right: -1500px;
        }
    }
    .hide-left {
        @include tft(translate3d(-100%,0,0))
    }
    .hide-right {
        @include tft(translate3d(100%,0,0))
    }
    .section-right{
        padding-left: 3px;
        align-items: flex-start;
        .section-dot-origin{
            @extend %pa;
            left: -1500px;
        }
    }
    .content-item{
        @extend %db;
        @extend %pr;
        flex-direction: column;
        color: #ffffff;
        margin-top: 6px;
        &:hover{
            .content-info{
                opacity: 0;
            }
        }
    }
    .content-info{
        @extend %pa;
        @extend %t0;
        @extend %l0;
        @extend %r0;
        @extend %b0;
        @extend %df;
        @include tst(all,.3s);
        opacity: 0.3;
        color: #ccc;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: rgba(0,0,0,.5);
        box-shadow: 0 0 50px rgba(0,0,0,0.8) inset;
    }
    .content-title{
        @extend %fwn;
        font-size: 12px;
        margin: 5px 20px;
        text-align: center;
    }
    .content-time{
        background-color: #fff;
        padding: 5px;
        border-radius: 30px;
    }
    .content-header-image{
        @extend %db;
        @extend %h100;
        width: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/body-wrap.vue